import { render, staticRenderFns } from "./ApplicantData.vue?vue&type=template&id=52d7970c&"
import script from "./ApplicantData.vue?vue&type=script&lang=ts&"
export * from "./ApplicantData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d7970c')) {
      api.createRecord('52d7970c', component.options)
    } else {
      api.reload('52d7970c', component.options)
    }
    module.hot.accept("./ApplicantData.vue?vue&type=template&id=52d7970c&", function () {
      api.rerender('52d7970c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/ApplicantData.vue"
export default component.exports